import { render, staticRenderFns } from "./PopupOverlay.vue?vue&type=template&id=6a74887a&scoped=true"
import script from "./PopupOverlay.vue?vue&type=script&lang=js"
export * from "./PopupOverlay.vue?vue&type=script&lang=js"
import style0 from "./PopupOverlay.vue?vue&type=style&index=0&id=6a74887a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a74887a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a74887a')) {
      api.createRecord('6a74887a', component.options)
    } else {
      api.reload('6a74887a', component.options)
    }
    module.hot.accept("./PopupOverlay.vue?vue&type=template&id=6a74887a&scoped=true", function () {
      api.rerender('6a74887a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/PopupOverlay.vue"
export default component.exports